import React from "react";

function Notification(props) {
  return (
    <div className="notification_wrap">
      <div className="msg_wrap success_notify">
        <div className="msg_wrap_inner alert">
          <div className="msg_icon">
            <svg
              fill="#f98f2f"
              fillRule="evenodd"
              height="30px"
              width="30px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 30 30"
            >
              <title>offline</title>
              <path
                d="M22.18,6a15,15,0,1,0,15,15A15,15,0,0,0,22.18,6Zm0,28a13,13,0,1,1,13-13A13,13,0,0,1,22.18,34Zm-1-10h2V14h-2Zm0,4h2V26h-2Z"
                transform="translate(-7.18 -6.03)"
              />
            </svg>
          </div>
          <div className="msg_icon" style={{ display: "none" }}>
            <svg
              fill="#64bc46"
              fillRule="evenodd"
              height="30px"
              width="30px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>selected</title>
              <path
                d="M301.71,432.31a10,10,0,1,1,10-10A10,10,0,0,1,301.71,432.31Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,301.71,414.3Zm-4.17,7.22,1.31-1.21,2.62,2.67,3.93-4,1.31,1.17-5.24,5.5Z"
                transform="translate(-291.71 -412.31)"
              />
            </svg>
          </div>
          <p className="msg_wrap_test">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard
          </p>
        </div>
        <div className="msg_wrap_close">
          <a className="close_info">
            <svg
              fill="#7293af"
              height="13px"
              width="13px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 13.31 13.31"
            >
              <title>close</title>
              <polygon
                className="cls-1"
                points="13.31 1.82 11.49 0 6.66 4.84 1.82 0 0 1.82 4.84 6.66 0 11.49 1.82 13.31 6.66 8.47 11.49 13.31 13.31 11.49 8.47 6.66 13.31 1.82"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Notification;
